import { AI_QUOTA_USAGE_STATUS, type AIQuotaSnapshot, type AIQuotaUsage } from 'core/hooks/useAIQuota';

const FULL_PERCENT = 100;

/**
 * Rounds down so "100%" only shows once the quota is spent, and caps at 100 because two concurrent
 * turns can overspend it.
 */
export function getQuotaUsage(snapshot: AIQuotaSnapshot | null): AIQuotaUsage | null {
  if (snapshot === null || snapshot.quota === null) {
    return null;
  }

  const { consumed, quota } = snapshot;
  if (consumed >= quota) {
    return { consumed, percent: FULL_PERCENT, quota, status: AI_QUOTA_USAGE_STATUS.EXHAUSTED };
  }

  const percent = Math.floor((consumed * FULL_PERCENT) / quota);
  const status = consumed === 0 ? AI_QUOTA_USAGE_STATUS.UNUSED : AI_QUOTA_USAGE_STATUS.IN_USE;
  return { consumed, percent, quota, status };
}
